var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { localized } from '@lit/localize';
import { CommonMessages } from '../../localization/helpers.js';
let SimpleTable = class SimpleTable extends LitElement {
    render() {
        if (!this.tableData || !this.tableData.columns || !this.tableData.rows) {
            return html `<p>${CommonMessages.noData()}</p>`;
        }
        return html `
      <table>
        <thead>
          <tr>
            ${this.tableData.columns.map(column => html `<th>${column}</th>`)}
          </tr>
        </thead>
        <tbody>
          ${this.tableData.rows.map(row => html `
            <tr>
              ${this.tableData.columns.map(column => html `<td>${row[column] || ''}</td>`)}
            </tr>
          `)}
        </tbody>
      </table>
    `;
    }
};
SimpleTable.styles = css `
    table {
      width: 100%;
      border-collapse: collapse;
      font-family: inherit;
      font-size: 0.75rem; /* Réduction de 25% */
    }
    th, td {
      border: 1px solid #ddd;
      padding: 6px; /* Réduction de 25% */
      text-align: left;
    }
    th {
      background-color: #f4f4f4;
      font-weight: bold;
    }
    tr:nth-child(even) {
      background-color: #f9f9f9;
    }
    tr:hover {
      background-color: #f1f1f1;
    }
  `;
__decorate([
    property({ type: Object })
], SimpleTable.prototype, "tableData", void 0);
SimpleTable = __decorate([
    localized(),
    customElement('simple-table')
], SimpleTable);
export { SimpleTable };
//# sourceMappingURL=SimpleTable.js.map